/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


 // Load video content after page load, its pupose is to increase page speed the performance
 // and instead of autolpay attribute on the video tag, this JS simply will set the video on play when the page content is loaded
 // The function will effect on multiple selectors
 $(window).on('load', function() {
     $("video.landing-video, .360video, .promovideo").each(function() {
       this.play();
     });
 });

/* JS Caoursel at Buy Box Section for Product Page */
var slideIndex = 1;
showSlides(slideIndex);

function plusSlides(n) {
  showSlides(slideIndex += n);
}

function currentSlide(n) {
  showSlides(slideIndex = n);
}

function showSlides(n) {
  var i;
  var slides = document.getElementsByClassName("reviewSlides");
  if (slides.length == 0) return
  //var dots = document.getElementsByClassName("dot");
  if (n > slides.length) {slideIndex = 1}
  if (n < 1) {slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
  }
  //for (i = 0; i < dots.length; i++) {
      //dots[i].className = dots[i].className.replace(" active", "");
  //}
  slides[slideIndex-1].style.display = "flex";
  //dots[slideIndex-1].className += " active";
}

// Variant specific content
var queryString = window.location.search;
var urlParams = new URLSearchParams(queryString);
var variantId = urlParams.get('variant');

var selectedValue = $('option').filter(":selected").attr('value');
var currentSku = $('option').filter(":selected").attr('data-sku');

if(variantId == selectedValue || selectedValue) {
  $('.variant-content').hide(0);
  $('.variant-content[data-sku="'+currentSku+'"]').show(0);
}

document.addEventListener('variant:changed', function(event) {
 var variant = event.detail.variant; // Get the variant that was added
  var currentSku = variant.sku;
  $('.variant-content').hide();
  $('.variant-content[data-sku="'+currentSku+'"]').show();
});

window.onload = function() {
  let reviewItems = document.getElementsByClassName("jdgm-rev-widg");
  let reviewItem = reviewItems[0];
  let reviewWrapper = document.getElementById("judgeme_product_reviews");
  for(let i = 0; i < reviewItems.length; i++) {
    if(reviewItems[0].getAttribute("data-number-of-reviews") == "0") {
      reviewWrapper.classList.add("review-hide");
      console.log("Added");
    } else {
      reviewWrapper.classList.remove("review-hide");
      console.log("removed");
    }
  }
};